import PropTypes from 'prop-types';

// Simple for comparable and layers where is only one level
// Need more complex for site finder, field can be set afterwards, rules can have children, common properties but not always
// Different PropType based on type

export const ListOptionsItemPropType = PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    category: PropTypes.string
});

export const FieldSettingsPropType = PropTypes.shape({
    // select only
    listOptions: PropTypes.arrayOf(ListOptionsItemPropType),
    // date only
    format: PropTypes.string,
    afterPlaceholder: PropTypes.string,
    beforePlaceholder: PropTypes.string,
    // string only
    autocomplete: PropTypes.bool,
    autocompleteFacetId: PropTypes.number,
    autocompleteOptions: PropTypes.arrayOf(PropTypes.string)
});

export const fieldPropTypes = {
    category: PropTypes.string,
    label: PropTypes.string.isRequired,
    order: PropTypes.number,
    settings: FieldSettingsPropType,
    tags: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.oneOf(['select', 'multiselect', 'integer', 'date', 'string', 'multistring', 'reference', 'area']).isRequired,
    tooltip: PropTypes.string,
    settingsInherit: PropTypes.string,
    isRequired: PropTypes.bool
};
export const FieldPropType = PropTypes.shape(fieldPropTypes);

export const RulePropertiesPropType = PropTypes.shape({
    // number for number, string for date
    value0: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    value1: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    // string for string or select,
    value: PropTypes.string,
    // string for multiselect
    values: PropTypes.arrayOf(PropTypes.string),
    operator: PropTypes.oneOf(['between', 'after', 'before', '==', 'ilike', 'greater', 'less'])
});

export const rulePropTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['group', 'group-rule', 'rule']).isRequired,
    field: PropTypes.string.isRequired,
    properties: RulePropertiesPropType.isRequired
};
export const RulePropType = PropTypes.shape(rulePropTypes);

export const groupPropTypes = {
    id: PropTypes.string.isRequired,
    not: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['group', 'group-rule', 'rule']).isRequired,
    conjunction: PropTypes.oneOf(['and', 'or']).isRequired,
    children: PropTypes.arrayOf(RulePropType).isRequired
};
export const GroupPropType = PropTypes.shape(groupPropTypes);

export const filterPropTypes = {
    tree: RulePropType.isRequired,
    field: FieldPropType.isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired
};
export const FilterPropType = PropTypes.shape(filterPropTypes);